module.exports = __webpack_public_path__ + "img/device.f923421b.png";